import { render, staticRenderFns } from "./CadastroVendaDireta.vue?vue&type=template&id=56ba3c11&"
import script from "./CadastroVendaDireta.vue?vue&type=script&lang=js&"
export * from "./CadastroVendaDireta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports